import $ from 'jquery';

export default function customScriptv1() {
$(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 1200) {
        $(".fixedbar").addClass("bluebackbg");
    } else {
        $(".fixedbar").removeClass("bluebackbg");
    }
});

$(window).scroll(function() {
  var scroll = $(window).scrollTop();

  if (scroll >= 100) {
      $("#positionSticky").addClass("position-sticky");
  } else {
      $("#positionSticky").removeClass("bluebackbg");
  }
});

// Detsils Box Start

$('#signUp').click(function(){
    $(loginForm).toggleClass("right-panel-active");
});

$('#signIn').click(function(){
    $(loginForm).removeClass("right-panel-active");
});

$('#navbtn').click(function(){
    $(navbox).toggleClass("show-nav");
});

$('#navbtn').click(function(){
    $(navbtn).toggleClass("is-open");
});

$('#advBtn').click(function(){
    $(advanceSearch).toggle();
});

$('#advanceClose').click(function(){
    $(advanceSearch).toggle();
});

$('#linkIssue').click(function(){
    $(issueList).toggleClass("slide-left");
});

$('#linkActivity').click(function(){
    $(activityStream).toggleClass("slide-right");
});

$('#showProject').click(function(){
    $(chatleft).toggleClass("chatleft");
});

$('#closeProject').click(function(){
    $(chatleft).removeClass("chatleft");
});

$('#showUser').click(function(){
    $(chatright).toggleClass("chatright");
});

$('#closeChat').click(function(){
    $(chatright).removeClass("chatright");
});

$('#activityFullbtn').click(function(){
    $(activityShow).addClass("activitypopshow");
    $(document.body).addClass('modal-open activity-modal-show');
});

$('#activityClosebtn').click(function(){
    $(activityShow).removeClass("activitypopshow");
    $(document.body).removeClass('modal-open activity-modal-show');
});

$('#menuClick').click(function(){
    $(v1MenuOpen).toggleClass('show-menu');
    $(menuClick).toggleClass('close-menu');
});
// $('#searchclick').click(function(){
//     $(searchOpen).toggleClass('open-search');
   
// });

$('#customDateButton').click(function(){
  $(customDateButton).toggleClass("active");
  $(customDateBoxShow).toggleClass("custom-date-box-show");
});

$('#recordingPauseBtn').click(function(){
  $(recordingPauseBtn).toggleClass("recording-play");
});

// $(document).ready(function(){
//     $("#cloneadd").click(function(){
//       $("#clone").clone().appendTo("#showclone");
//     });
//   });


$('#btnA').click(function(){
    $('#showbtnA').toggle();
    $('#hidebtnA').toggle();
  });

$('#btnB').click(function(){
    $('#showbtnB').toggle();
    $('#hidebtnB').toggle();
  });

$('#btnC').click(function(){
    $('#showbtnC').toggle();
    $('#hidebtnC').toggle();
  });

$('#btnD').click(function(){
    $('#showbtnD').toggle();
    $('#hidebtnD').toggle();
  });

$('#btnE').click(function(){
    $('#showbtnE').toggle();
    $('#hidebtnE').toggle();
  });

$('#btnF').click(function(){
    $('#showbtnF').toggle();
    $('#hidebtnF').toggle();
  });

$('#secretKeyclick').click(function(){
    $('#secretKeyshow').toggle();
  });

$('.update-key').click(function(){
    $('#secretKeyshow').toggle();
  });

$('#cancelA').click(function(){
    $('#showbtnA').toggle();
    $('#hidebtnA').toggle();
  });

$('#doneA').click(function(){
    $('#hidebtnA').toggle();
    $('#showbtnA').toggle();
  });

$('#cancelB').click(function(){
    $('#showbtnB').toggle();
    $('#hidebtnB').toggle();
  });

$('#doneB').click(function(){
    $('#hidebtnB').toggle();
    $('#showbtnB').toggle();
  });

$('#cancelC').click(function(){
    $('#showbtnC').toggle();
    $('#hidebtnC').toggle();
  });

$('#doneC').click(function(){
    $('#hidebtnC').toggle();
    $('#showbtnC').toggle();
  });

$('#cancelD').click(function(){
    $('#showbtnD').toggle();
    $('#hidebtnD').toggle();
  });

$('#doneD').click(function(){
    $('#hidebtnD').toggle();
    $('#showbtnD').toggle();
  });

$('#cancelE').click(function(){
    $('#showbtnE').toggle();
    $('#hidebtnE').toggle();
  });

$('#doneE').click(function(){
    $('#hidebtnE').toggle();
    $('#showbtnE').toggle();
  });

$('#cancelF').click(function(){
    $('#showbtnF').toggle();
    $('#hidebtnF').toggle();
  });

$('#doneF').click(function(){
    $('#hidebtnF').toggle();
    $('#showbtnF').toggle();
  });


  //  Participants Dropdown Start

$('#openParticipants').click(function(){
    $('#participants').toggleClass("show");
  });

$('#closeParticipants').click(function(){
   $('#participants').toggleClass("show");
  });

$('#addCategoryButton').click(function(){
    $('#categoryForm').toggleClass("display-show");
    $('#addCategoryButton').toggleClass("display-hide");
   });
  //  Participants Dropdown End

  // Call Chat Section Start

$('.main-chat-btn').click(function(){
 $('#chatBox').toggleClass("show");
});

$('#viewMoreAnswer').on('click',function() {
  $('#showMoreAnswers').toggleClass('more-answers');
  $(this).toggleClass('show-less-span');
});

$('.s_v_chat').click(function(){
  $('#chatBox').toggleClass("show");
 });

$('.chat-close').click(function(){
  $('#chatBox').toggleClass("show");
});

$('#answerItButton').click(function(){
  $('#writeAnswer').removeClass("display-hide");
});

  //  Call Chat Section Right



  // Participants

  $('#inviteBtn').click(function(){
    $('#participantChat').toggle();
    $('#participantInvite').toggle();
    $('#pHd').toggle();
    $('#pSch').toggle();
    $(this).toggleClass("no-icon");
    if (this.innerHTML=="invite") {
      this.innerHTML = "Done";
    }
    else{
      this.innerHTML = "invite";
    } 
  });

  // Participants

  $('.main-mute-btn').click(function(){
    $('.main-mute-btn').toggleClass("main-mute-on-btn");
  });

  $('.main-scrn-stop-btn').click(function(){
    $('.main-scrn-stop-btn').toggleClass("main-scrn-stop-on-btn");
    window.location.href = "video-is-not-turn-on.html";
  });

  $('.main-scrn-record-btn').click(function(){
    $('.main-scrn-record-btn').toggleClass("main-scrn-record-on-btn");
  });
  

  //  Chat Seen User Pop

  $('#seenPop').click(function(event){
    event.stopPropagation();
    $('#seenPopshow').toggle();
  });

  $(document).on("click", function () {
    $("#seenPopshow").hide();
  });



  $('.call_mute__btn').click(function(){
    $('.call_mute__btn').toggleClass("callmute");
  });
  $('.call_video__btn').click(function(){
    $('.call_video__btn').toggleClass("videomute");
  });



  $('.caller_mac').click(function(){
    $('.caller_mac').toggleClass("caller_mac_mute");
  });

  $('.caller_video').click(function(){
    $('.caller_video').toggleClass("caller_video_mute");
  });
  
  $('.s_m_icon').click(function(){
    $('.s_m_icon').toggleClass("s_m_icon_mute");
  });
  
  $('.applicant-basic-information ul li a').click(function(){
    $('a').removeClass('active');
    $(this).addClass('active');
  });

  $('.members-count ul li button').click(function(){
    $('button').removeClass('active');
    $(this).addClass('active');
  });
}